import { Injector } from '@angular/core';
import { Validators } from '@angular/forms';
import { ColumnSizes, FilterType } from 'components';
import { Report } from '../../models/report';
import { SubmittedClaimsService } from './submitted-claims.service';

export const SubmittedClaims: Report = {
  id: 'submitted-claims',
  label: 'Submitted Claims Report',
  textCriteria: { 'Start Date': '', 'End Date': '' },
  cleanFilterParams: {},
  getReportTitle: () => {
    return SubmittedClaims.label + ' ' + SubmittedClaims.textCriteria['Start Date'] + ' - ' + SubmittedClaims.textCriteria['End Date']
  },
  getSearchCriteria: (injector: Injector) => [
    {
      controls: [
        {
          label: 'Submitted Date Range',
          name: 'dateRange',
          type: 'dateRange',
          class: 'form-span-12',
          daterangeStartChanged: (event) => {
            SubmittedClaims.textCriteria['Start Date'] = event.value.toLocaleDateString();
          },
          daterangeEndChanged: (event) => {
            SubmittedClaims.textCriteria['End Date'] = event.value.toLocaleDateString();
          }
        },
        {
          label: '',
          name: 'dateRangeStart',
          type: 'noInput',
          class: 'display-none',
          validators: Validators.required
        },
        {
          label: '',
          name: 'dateRangeEnd',
          type: 'noInput',
          class: 'display-none',
          validators: Validators.required
        }
      ]
    }
  ],
  getGridConfiguration: (injector: Injector) => {
    const moneyFormat = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
    return {
      service: injector.get<any>(SubmittedClaimsService),
      columnDefinitions: [
        {
          id: 'Created Date',
          displayKey: 'Created Date',
          headerText: 'Created Date',
          displayOrder: 0,
          columnSize: ColumnSizes.date,
          filterable: true,
          sortable: true,
          sortColumnType: 'date',
          filterConfig: {
            filterType: FilterType.date
          }
        },
        {
          id: 'Original Claims',
          displayKey: 'Original Claims',
          headerText: 'Original Claims',
          displayOrder: 1,
          columnSize: ColumnSizes.normal,
          filterable: true,
          sortable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          }
        },
        {
          id: 'Rebilled Claims',
          displayKey: 'Rebilled Claims',
          headerText: 'Rebilled Claims',
          displayOrder: 2,
          columnSize: ColumnSizes.normal,
          filterable: true,
          sortable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          }
        },
        {
          id: 'Voided Claims',
          displayKey: 'Voided Claims',
          headerText: 'Voided Claims',
          displayOrder: 3,
          columnSize: ColumnSizes.normal,
          filterable: true,
          sortable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          }
        },
        {
          id: 'Group Claims',
          displayKey: 'Group Claims',
          headerText: 'Group Claims',
          displayOrder: 4,
          columnSize: ColumnSizes.normal,
          filterable: true,
          sortable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          }
        },
        {
          id: 'Total Claims',
          displayKey: 'Total Claims',
          headerText: 'Total Claims',
          displayOrder: 5,
          columnSize: ColumnSizes.normal,
          filterable: true,
          sortable: true,
          sortColumnType: 'number',
          filterConfig: {
            filterType: FilterType.number
          }
        }
      ]
    };
  }
};
